import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2, MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

const LOGO_SRC = "https://customer-assets.emergentagent.com/job_monarch-style/artifacts/2795r72c_IMG_3956.jpeg";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-monarch-black border-t border-monarch-gold/15 mt-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-4 mb-6">
            <img src={LOGO_SRC} alt="Monarch Cutz" className="h-20 w-auto object-contain" />
          </Link>
          <p className="text-monarch-ash text-sm leading-relaxed max-w-md">
            A modern barbershop built on old-world ritual. Precision cuts, hot-towel shaves,
            and the kind of unhurried attention that turns a haircut into an experience.
          </p>
          <div className="flex flex-col gap-3 mt-7">
            <a href={SITE.social.instagram.url} target="_blank" rel="noreferrer" data-testid="footer-instagram"
               className="inline-flex items-center gap-3 text-monarch-cream/85 hover:text-monarch-gold transition-colors group">
              <span className="w-10 h-10 border border-monarch-gold/30 group-hover:border-monarch-gold group-hover:bg-monarch-gold/10 transition-colors flex items-center justify-center shrink-0">
                <Instagram className="w-4 h-4 text-monarch-gold" />
              </span>
              <span className="text-sm">{SITE.social.instagram.handle}</span>
            </a>
            <a href={SITE.social.facebook.url} target="_blank" rel="noreferrer" data-testid="footer-facebook"
               className="inline-flex items-center gap-3 text-monarch-cream/85 hover:text-monarch-gold transition-colors group">
              <span className="w-10 h-10 border border-monarch-gold/30 group-hover:border-monarch-gold group-hover:bg-monarch-gold/10 transition-colors flex items-center justify-center shrink-0">
                <Facebook className="w-4 h-4 text-monarch-gold" />
              </span>
              <span className="text-sm">{SITE.social.facebook.handle}</span>
            </a>
            <a href={SITE.social.tiktok.url} target="_blank" rel="noreferrer" data-testid="footer-tiktok"
               className="inline-flex items-center gap-3 text-monarch-cream/85 hover:text-monarch-gold transition-colors group">
              <span className="w-10 h-10 border border-monarch-gold/30 group-hover:border-monarch-gold group-hover:bg-monarch-gold/10 transition-colors flex items-center justify-center shrink-0">
                <Music2 className="w-4 h-4 text-monarch-gold" />
              </span>
              <span className="text-sm">{SITE.social.tiktok.handle}</span>
            </a>
            <a href={SITE.social.reddit.url} target="_blank" rel="noreferrer" data-testid="footer-reddit"
               className="inline-flex items-center gap-3 text-monarch-cream/85 hover:text-monarch-gold transition-colors group">
              <span className="w-10 h-10 border border-monarch-gold/30 group-hover:border-monarch-gold group-hover:bg-monarch-gold/10 transition-colors flex items-center justify-center shrink-0">
                <MessageCircle className="w-4 h-4 text-monarch-gold" />
              </span>
              <span className="text-sm">Discuss on {SITE.social.reddit.handle}</span>
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5">Visit</div>
          <p className="text-monarch-cream text-sm leading-relaxed">{SITE.address}</p>
          <a href={SITE.phoneHref} className="block mt-3 text-monarch-gold hover:text-monarch-champagne transition-colors text-sm">{SITE.phone}</a>
          <a href={`mailto:${SITE.email}`} className="block mt-1 text-monarch-ash hover:text-monarch-gold text-sm transition-colors">{SITE.email}</a>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow mb-5">Hours</div>
          <ul className="space-y-2 text-sm">
            {SITE.hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-3 text-monarch-cream/80">
                <span>{h.day}</span>
                <span className="text-monarch-ash">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow mb-5">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/barbers" className="text-monarch-cream/80 hover:text-monarch-gold transition-colors">Our Barbers</Link></li>
            <li><Link to="/shop" className="text-monarch-cream/80 hover:text-monarch-gold transition-colors">The Shop</Link></li>
            <li><Link to="/journal" className="text-monarch-cream/80 hover:text-monarch-gold transition-colors">The Journal</Link></li>
            <li><Link to="/book" className="text-monarch-cream/80 hover:text-monarch-gold transition-colors">Book a Chair</Link></li>
            <li><Link to="/contact" className="text-monarch-cream/80 hover:text-monarch-gold transition-colors">Contact</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-monarch-gold/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-monarch-ash">
          <p>&copy; {new Date().getFullYear()} Monarch Cutz. All rights reserved.</p>
          <p className="tracking-[0.25em] uppercase">Crafted with the precision of a fresh line-up.</p>
        </div>
      </div>
    </footer>
  );
}
